// AD-2791: the Form details box clears a form's expiry date when the date it opened with has been removed.
export const shouldClearExpiry = (expiryWhenOpened, expiryNow) => !expiryNow && !!expiryWhenOpened;
